import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GroupCoreProvider } from './GroupCoreContext';
import { FacilityProvider } from './FacilityContext';
import { ListingProvider } from './ListingContext';
import { ErrorProvider } from './ErrorContext';

// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false
    },
  },
});

/**
 * Combined provider that integrates all Group Intake contexts
 * Provides a clean API for consuming components and handles proper nesting
 */
export const GroupIntakeProvider = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorProvider>
        <GroupCoreProvider>
          <FacilityProvider>
            <ListingProvider>
              {children}
            </ListingProvider>
          </FacilityProvider>
        </GroupCoreProvider>
      </ErrorProvider>
    </QueryClientProvider>
  );
};

// Re-export all the context hooks for easy imports
export { useGroupCore } from './GroupCoreContext';
export { useFacility } from './FacilityContext';
export { useListing } from './ListingContext';
export { useError } from './ErrorContext';

// For backward compatibility
export { GroupIntakeProvider as GroupIntakeWithQueryProvider };
